// Internal employer IDs that we don't want to allow to log in as employer from ACP
export const loginAsEmployerBlacklistedIds = [2344, 2347]
